import config from 'config'

export const localStorageCleanup = () => {
  localStorage.removeItem(config.SELECTED_PBX_ID)
  localStorage.removeItem(config.DISMISSED_BANNERS)
  localStorage.removeItem(config.AUTH_TOKEN_KEY)
  localStorage.removeItem(config.I_AM_TOKEN_KEY)
  localStorage.removeItem(config.TAX_EXEMPTION_BANNER_ID)
}

export const localStorageCleanupAndDeleteSelectedAccountKey = () => {
  localStorageCleanup()
  localStorage.removeItem(config.SELECTED_ACCOUNT_KEY)
}
